const subscriptionStatusEndpoint = '/ajax/subscription/status';
const subscriptionsLabelsEndpoint = '/ajax/subscriptions';

const fetcheSubscriptionStatus = async function () {
  try {
    const response = await fetch(subscriptionStatusEndpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.json();
  } catch (error) {
    console.error('Error fetching subscription status:', error);
    throw error;
  }
};

const fetchSubscriptionLabels = async function (ids = []) {
  const url = `${subscriptionsLabelsEndpoint}?ids=${ids.join('|')}`;
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.json();
  } catch (error) {
    console.error('Error fetching subscription labels:', error);
    throw error;
  }
};

const addUserStatusClasses = async function () {
  const { active_subscription } = await fetcheSubscriptionStatus();
  const statusClass = active_subscription
    ? 'user-subscription-active'
    : 'user-subscription-inactive';
  document.querySelector('body').classList.add(statusClass);
  document.querySelector('body').classList.remove('user-subscription-unknown');
};

export default {
  fetcheSubscriptionStatus,
  fetchSubscriptionLabels,
  addUserStatusClasses,
};
